import { render, staticRenderFns } from "./MiuVipPlan.vue?vue&type=template&id=398278c5&scoped=true"
import script from "./MiuVipPlan.vue?vue&type=script&lang=js"
export * from "./MiuVipPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398278c5",
  null
  
)

export default component.exports